// Importing necessary libraries and middleware
import { createStore, compose, applyMiddleware } from "redux"; // For creating the Redux store
import thunk from "redux-thunk"; // Middleware for handling asynchronous actions
import throttle from "lodash/throttle"; // Utility to throttle function calls
// import logger from "redux-logger"; // Middleware for logging Redux actions
import { handleInitialData } from "./Actions/appActions"; // Initial data action

import rootReducer from "./Reducers/Index"; // Root reducer combining all reducers

// Setting up Redux DevTools extension for debugging
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// Creating the Redux store with middleware
export const store = createStore(
  rootReducer, // Root reducer
  composeEnhancers(applyMiddleware(thunk))
);

// Subscribing to the store with throttling to limit updates
store.subscribe(throttle(() => store.getState(), 1000));

// Dispatching the initial data action to populate the store
store.dispatch(handleInitialData());
